import * as administrationActions from '../../admin/administrationActions'
import * as systemActions from '../../systemManager/systemActions'
import * as workorderActions from '../workorderActions'
import { Checkbox } from '@atd/rui-base.mui.checkbox'
import { FormControlLabel } from '@atd/rui-base.mui.form-control-label'

import ButtonBar, {buttonPrototype} from '../../commonComponents/buttonBar'

import DispatchDialog from './dispatchDialog'
import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

function mapStateToProps(state, ownProps) {
    return {
        cloudJob: state.workorder.cloudJob,
        workorderUuid: state.workorder.workorderUuid,
    }
}


function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators(workorderActions, dispatch),
        ...bindActionCreators(systemActions, dispatch),
    }
}

export class DispatchBar extends React.Component {
    static defaultProps = {
        archived: true,
        downloadOverrides: {},
        dispatchOverrides: {},
        templateOverrides: {},
        frontChildren: [],
        backChildren: [],
        cloudCheckboxDisabled: true,
        saved: false,
        disabled: false, // for the entire bar, overrides other disabled states
        releasedTime: null,
        notOwner: false,

        validateAndSaveWorkorder: async() => { return false },
    }
    constructor(props) {
        super(props)
        this.state = {
            dispatchOpen: false,
            message: '',
            downloadAccess: administrationActions.userHasRavenServiceAccess(),
        }
    }
    componentDidMount() {
        this.setState({
            dispatchOpen: false,
            message: '',
        })
    }

    componentDidUpdate(prevProps) {
        if (prevProps.workorderUuid !== this.props.workorderUuid) {
            this.setState({
                message: '',
            })
        }
    }

    handleCloudJob = (event, checked) => {
        this.props.setCloudJob(checked)
    }

    dispatchRequested = async() => {
        if (!this.props.saved) {
            if (!(await this.props.validateAndSaveWorkorder())) { return }
        }
        if (!this.props.archived) {
            this.setState({dispatchOpen: true})
        }
        else {
            this.setState({message: 'Cannot dispatch archived job'})
        }
    }
    renderDispatcher = () => {
        if (this.state.dispatchOpen) {
            return <DispatchDialog open={true} onClose={this.handleClose} onDispatch={this.dispatchWorkorder}/>
        }
    }
    handleClose = () => {
        this.setState({dispatchOpen: false})
    }
    dispatchWorkorder = () => {
        this.setState({dispatchOpen: false, message: 'Dispatch successful'})
    }

    downloadRequested = async() => {
        if (!this.props.saved) {
            if (!(await this.props.validateAndSaveWorkorder())) { return }
        }
        this.props.downloadWorkPackage(this.props.workorderUuid)
    }

    render() {
        return (
            <div name="dispatchBar" style={{paddingTop: 30}}>
                <FormControlLabel
                    label="Available as Cloud Job"
                    control={
                        <Checkbox
                            checked={this.props.cloudJob}
                            onChange={this.handleCloudJob}
                            disabled={this.props.cloudCheckboxDisabled || this.props.disabled}
                            name="cloudJobAvailability"
                            sx={{color: 'var(--secondary)', '&.Mui-checked': {color: 'var(--secondary)'}}}
                        />
                    }
                />
                <ButtonBar disabled={this.props.disabled} mobileFilled children = {[
                    ...this.props.frontChildren,
                    buttonPrototype(Object.assign({
                        label: 'Dispatch',
                        iconPath: `jobIcons/Job_DispatchWhite`,
                        mobileIconPath: `jobCard/JobCard_BtnDispatch`,
                        disabledIconPath: `jobIcons/Job_DispatchDisabled`,
                        onClick: this.dispatchRequested,
                        visible: !this.props.archived,
                        disabled: !this.props.workorderUuid || this.props.releasedTime == null || new Date(this.props.releasedTime) > new Date() || !!this.props.notOwner,
                        disabledTooltip: this.props.releasedTime == null || new Date(this.props.releasedTime) > new Date() ? 'Unreleased jobs cannot be dispatched' : '',
                    }, this.props.dispatchOverrides)),
                    buttonPrototype(Object.assign({
                        label: 'Template',
                        iconPath: `jobIcons/Job_CreateAnotherWhite`,
                        mobileIconPath: `jobIcons/Job_CreateAnotherBlue`,
                        disabledIconPath: `jobIcons/Job_CreateAnotherDisabled`,
                        disabled: !this.props.workorderUuid || !!this.props.notOwner,
                    }, this.props.templateOverrides)),
                    buttonPrototype({
                        disabled: !this.props.jobReportAvailable,
                        label: 'Job Report',
                        iconPath: `jobIcons/Job_ViewReport`,
                        mobileIconPath: `jobIcons/Job_ViewReportBlue`,
                        disabledIconPath: `jobIcons/Job_ViewReportDisabled`,
                        href: `/jobs/applicationreport/${this.props.workorderUuid}`,
                    }),
                    ...this.props.backChildren,

                    // We always put download at the back because it is internal only
                    buttonPrototype(Object.assign({
                        label: 'Download',
                        iconPath: `jobIcons/Job_Download`,
                        mobileIconPath: `jobIcons/Job_DownloadBlue`,
                        disabledIconPath: `jobIcons/Job_DownloadDisabled`,
                        onClick: this.downloadRequested,
                        visible: this.state.downloadAccess,
                        disabled: !this.props.workorderUuid || !this.state.downloadAccess,
                    }, this.props.downloadOverrides)),
                ]}/>
                <div style={{color: 'red'}}>{this.state.message}</div>
                {this.renderDispatcher()}
            </div>
        )
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(DispatchBar)
